<template>
  <div>
    <div class="row">
      <b-form-group
        id="input-training-id"
        :label="$t('training-add.id')"
        label-for="input-id"
        label-align="left"
        class="col-2"
      >
        <b-form-input
          id="input-id"
          type="text"
          v-model="activity.id"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-training-no"
        :label="$t('training-add.no')"
        label-for="input-no"
        label-align="left"
        class="col-lg-1 col-md-2"
      >
        <b-form-input
          id="input-no"
          type="text"
          v-model="activity.activityNo"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        v-if="modules != null"
        id="input-group-module"
        :label="$t('training-add.module')"
        label-align="left"
        class="col-lg-5 col-md-4"
      >
        <v-select
          :options="modules"
          :placeholder="$t('training-add.chooseAModule')"
          :clearable="false"
          :disabled="
            (!isAdmin && !isMod) ||
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          label="title"
          v-model="activity.module"
          class="bg-white rounded"
          @input="getTrainersByModuleId"
        >
          <template #no-options="{}">
            {{ $t("training-add.noOptions") }}
          </template>
        </v-select>
      </b-form-group>
      <b-form-group :label="$t('training-add.unit')" label-align="left" class="col-4">
        <v-select
          v-if="units"
          :options="units"
          :placeholder="$t('common.unit-selector.selectAUnit')"
          :disabled="
            (!isAdmin && !isMod) ||
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          v-model="activity.organizerUnit"
          label="name"
          :clearable="false"
          @input="unitSelected"
        >
          <template #no-options="{}">
            {{ $t("common.unit-selector.noOptions") }}
          </template>
        </v-select>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        id="input-training-status"
        :label="$t('training-add.status')"
        label-for="input-status"
        label-align="left"
        class="col-lg-3 col-md-4"
      >
        <b-form-input
          id="input-status"
          type="text"
          :value="this.$t('trainingStatusEnums.' + activity.status)"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-training-method"
        :label="$t('training-add.method')"
        label-for="training-method"
        label-align="left"
        class="col-lg-3 col-md-3"
      >
        <b-select
          id="training-method"
          v-model="activity.method"
          :options="activityMethods"
          :disabled="activity.status == 'SCHEDULED' && isMod && !isAdmin"
        >
          >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-group-applicationsDate"
        :label="$t('training-add.applicationsDate')"
        label-for="applicationsDate-datepicker"
        label-align="left"
        class="col-lg-2 col-md-3"
      >
        <b-form-datepicker
          id="applicationsDate-datepicker"
          :placeholder="this.$t('common.date')"
          v-model="activity.applicationsExpireDate"
          :min="$route.name == 'trainingAdd' ? today : null"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
          :state="this.invalidApplicationsDate ? false : null"
          v-b-tooltip.hover
          :title="this.invalidApplicationsDate ? 'Μη έγκυρη ημερομηνία' : ''"
          :disabled="
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          class="mb-2"
        >
        </b-form-datepicker>
      </b-form-group>

      <b-form-group
        :label="$t('training-add.location')"
        label-for="input-location"
        label-align="left"
        class="col-lg-3 col-md-4"
      >
        <b-form-input
          id="input-location"
          type="text"
          v-model="activity.location"
          :disabled="
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        id="input-training-amount"
        :label="$t('training-add.amount')"
        label-for="input-amount"
        label-align="left"
        class="col-lg-1 col-md-2"
      >
        <b-form-input
          id="input-amount"
          type="text"
          :value="activityCost + ' €'"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-notifiedUnits"
        :label="$t('training-add.paymentOptions')"
        label-for="input-notifiedUnits"
        label-align="left"
        class="col-6"
        v-if="
          activityCost > 0 &&
          (activity.status === 'PROPOSED' || activity.status === 'SCHEDULED')
        "
      >
        <v-select
          :options="paymentTypeOptions"
          label="text"
          :placeholder="$t('training-add.selectPayment')"
          v-model="activity.paymentTypes"
          multiple
          chips
          :disabled="!canChangePaymentTypes"
          :reduce="(cat) => cat.value"
        />
      </b-form-group>

      <b-form-group
        :label="$t('training-add.announcementTemplate')"
        label-align="left"
        class="col-4"
      >
        <v-select
          v-if="templates"
          :options="templates"
          :placeholder="$t('training-add.selectAnnouncement')"
          :disabled="
            (!isAdmin && !isMod) ||
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          v-model="activity.announcementTemplate"
          label="title"
          :clearable="false"
        >
          <template #no-options="{}">
            {{ $t("common.unit-selector.noOptions") }}
          </template>
        </v-select>
      </b-form-group>
    </div>
    <hr />
    <b-table
      :items="activity.periods"
      :fields="fields"
      responsive
      show-empty
      class="col-12"
      thead-class="esep-blue-bg text-light"
    >
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deletePeriod(row)"
          :disabled="
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('training-add.delete')"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-add.emptyTable") }}</h6>
      </template>
    </b-table>
    <div
      class="row mr-1"
      v-if="
        activity.status != 'COMPLETED' &&
        activity.status != 'REJECTED' &&
        activity.status != 'CANCELLED' &&
        !(activity.status == 'SCHEDULED' && isMod && !isAdmin)
      "
    >
      <b-form-group
        id="input-group-startDate"
        :label="$t('training-add.startDate')"
        label-for="startDate-datepicker"
        label-align="left"
        class="col-lg-2 col-md-4"
      >
        <b-form-datepicker
          id="startDate-datepicker"
          :placeholder="this.$t('common.date')"
          v-model="trainingPeriod.startDate"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group-startTime"
        :label="$t('training-add.startTime')"
        label-for="startTime-timepicker"
        label-align="left"
        class="col-md-2 col-lg-2"
      >
        <b-form-timepicker
          v-model="trainingPeriod.startTime"
          :locale="'en-GB'"
          placeholder=""
        ></b-form-timepicker>
      </b-form-group>
      <b-form-group
        id="input-group-endDate"
        :label="$t('training-add.endDate')"
        label-for="endDate-datepicker"
        label-align="left"
        class="col-md-4 col-lg-2"
      >
        <b-form-datepicker
          id="endDate-datepicker"
          :placeholder="this.$t('common.date')"
          v-model="trainingPeriod.endDate"
          :min="trainingPeriod.startDate"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
          class="mb-2"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group-endTime"
        :label="$t('training-add.endTime')"
        label-for="endTime-timepicker"
        label-align="left"
        class="col-md-2 col-lg-2"
      >
        <b-form-timepicker
          v-model="trainingPeriod.endTime"
          :locale="'en-GB'"
          placeholder=""
        ></b-form-timepicker>
      </b-form-group>
      <b-form-group
        id="input-training-location"
        :label="$t('training-add.location')"
        label-for="input-location"
        label-align="left"
        class="col-lg-4 col-md-6"
      >
        <b-form-input
          id="input-location"
          type="text"
          v-model="trainingPeriod.location"
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="row">
      <b-button
        variant="primary"
        class="esep-blue-bg col-lg-1 col-md-2 h-50 ml-auto mr-4"
        @click="addPeriod()"
        :disabled="
          trainingPeriod.location == null ||
          trainingPeriod.startDate == null ||
          trainingPeriod.endDate == null
        "
      >
        {{ $t("common.add") }}
      </b-button>
    </div>

    <hr />
    <div class="row" v-if="moduleTrainers">
      <b-form-group
        id="input-training-leader"
        :label="$t('training-add.leader')"
        label-for="input-leader"
        label-align="left"
        label-cols-sm="4"
        content-cols-sm
        class="col-5"
      >
        <v-select
          :options="moduleTrainers"
          :disabled="
            activity.status == 'COMPLETED' ||
            activity.status == 'REJECTED' ||
            activity.status == 'CANCELLED' ||
            (activity.status == 'SCHEDULED' && isMod && !isAdmin)
          "
          placeholder=""
          :clearable="false"
          v-model="trainingLeader"
          class="bg-white rounded"
          @input="staffChanged('LEADER', trainingLeader)"
        >
          <template #no-options="{}">
            {{ $t("training-add.noTrainers") }}
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        id="input-training-leader-telephone"
        :label="$t('training-add.telephone')"
        label-for="input-leader-telephone"
        label-align="left"
        label-cols-sm="5"
        content-cols-sm
        class="col-2"
      >
        <b-form-input
          id="input-leader-telephone"
          type="number"
          class="telephone"
          v-model="trainingLeader.cinfo.telNo"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-training-leader-mobile"
        :label="$t('training-add.mobile')"
        label-for="input-leader-mobile"
        label-align="left"
        label-cols-sm="4"
        content-cols-sm
        class="col-2"
      >
        <b-form-input
          id="input-leader-mobile"
          type="number"
          v-model="trainingLeader.cinfo.cellNo"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-training-leader-email"
        :label="$t('training-add.email')"
        label-for="input-leader-email"
        label-align="left"
        label-cols-sm="2"
        content-cols-sm
        class="col-3"
      >
        <b-form-input
          id="input-leader-email"
          type="text"
          v-model="trainingLeader.cinfo.email"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </div>
    <template
      v-if="
        this.$route.name == 'trainingView' &&
        (!isMod || isTrainer || isAdmin) &&
        branchTrainers
      "
    >
      <div class="row">
        <b-form-group
          id="input-training-program-subleader"
          :label="$t('training-view.programSubleader')"
          label-for="input-program-subleader"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-5"
        >
          <v-select
            :options="branchTrainers"
            placeholder=""
            :clearable="false"
            :disabled="
              activity.status == 'COMPLETED' ||
              activity.status == 'REJECTED' ||
              activity.status == 'CANCELLED'
            "
            v-model="programSubleader"
            class="bg-white rounded"
            @input="staffChanged('PROGRAM_SUBLEADER', programSubleader)"
          >
            <template #no-options="{}">
              {{ $t("training-add.noTrainers") }}
            </template>
          </v-select>
        </b-form-group>
        <b-form-group
          id="program-subleader-telephone"
          :label="$t('training-add.telephone')"
          label-for="program-subleader-telephone"
          label-align="left"
          label-cols-sm="5"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="program-subleader-telephone"
            type="number"
            class="telephone"
            v-model="programSubleader.cinfo.telNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="program-subleader-mobile"
          :label="$t('training-add.mobile')"
          label-for="program-subleader-mobile"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="program-subleader-mobile"
            type="number"
            v-model="programSubleader.cinfo.cellNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="program-subleader-email"
          :label="$t('training-add.email')"
          label-for="program-subleader-email"
          label-align="left"
          label-cols-sm="2"
          content-cols-sm
          class="col-3"
        >
          <b-form-input
            id="program-subleader-email"
            type="text"
            v-model="programSubleader.cinfo.email"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          id="logistics-subleader"
          :label="$t('training-view.logisticsSubleader')"
          label-for="logistics-subleader"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-5"
        >
          <v-select
            :options="branchTrainers"
            placeholder=""
            :clearable="false"
            :disabled="
              activity.status == 'COMPLETED' ||
              activity.status == 'REJECTED' ||
              activity.status == 'CANCELLED'
            "
            v-model="logisticsSubleader"
            class="bg-white rounded"
            @input="staffChanged('LOGISTICS_SUBLEADER', logisticsSubleader)"
          >
            <template #no-options="{}">
              {{ $t("training-add.noTrainers") }}
            </template>
          </v-select>
        </b-form-group>
        <b-form-group
          id="logistics-subleader-telephone"
          :label="$t('training-add.telephone')"
          label-for="logistics-subleader-telephone"
          label-align="left"
          label-cols-sm="5"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="logistics-subleader-telephone"
            type="number"
            class="telephone"
            v-model="logisticsSubleader.cinfo.telNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="logistics-subleader-mobile"
          :label="$t('training-add.mobile')"
          label-for="logistics-subleader-mobile"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="logistics-subleader-mobile"
            type="number"
            v-model="logisticsSubleader.cinfo.cellNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="logistics-subleader-email"
          :label="$t('training-add.email')"
          label-for="logistics-subleader-email"
          label-align="left"
          label-cols-sm="2"
          content-cols-sm
          class="col-3"
        >
          <b-form-input
            id="logistics-subleader-email"
            type="text"
            v-model="logisticsSubleader.cinfo.email"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="row" v-if="activeLeaders">
        <b-form-group
          id="input-training-secretary"
          :label="$t('training-view.secretary')"
          label-for="input-secretary"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-5"
        >
          <v-select
            :options="activeLeaders"
            placeholder=""
            :clearable="false"
            :disabled="
              activity.status == 'COMPLETED' ||
              activity.status == 'REJECTED' ||
              activity.status == 'CANCELLED'
            "
            v-model="secretary"
            :reduce="(trainer) => trainer.member"
            class="bg-white rounded"
            @input="staffChanged('SECRETARY', secretary)"
            @search="getActiveLeaders"
          >
            <template #no-options="{}">
              {{ $t("training-add.noTrainers") }}
            </template>
          </v-select>
        </b-form-group>
        <b-form-group
          id="secretary-telephone"
          :label="$t('training-add.telephone')"
          label-for="input-secretary-telephone"
          label-align="left"
          label-cols-sm="5"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="input-secretary-telephone"
            type="number"
            class="telephone"
            v-model="secretary.cinfo.telNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="secretary-mobile"
          :label="$t('training-add.mobile')"
          label-for="input-secretary-mobile"
          label-align="left"
          label-cols-sm="4"
          content-cols-sm
          class="col-2"
        >
          <b-form-input
            id="input-secretary-mobile"
            type="number"
            v-model="secretary.cinfo.cellNo"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="secretary-email"
          :label="$t('training-add.email')"
          label-for="input-secretary-email"
          label-align="left"
          label-cols-sm="2"
          content-cols-sm
          class="col-3"
        >
          <b-form-input
            id="input-secretary-email"
            type="text"
            v-model="secretary.cinfo.email"
            disabled
            placeholder=""
          ></b-form-input>
        </b-form-group>
      </div>
    </template>
    <hr
      v-if="
        (($route.name == 'trainingView' && !isMod) ||
          $route.name == 'trainingAdd' ||
          isAdmin) &&
        activity.status != 'COMPLETED'
      "
    />
    <div
      class="row ml-1"
      v-if="
        activity.status != 'COMPLETED' &&
        activity.status != 'REJECTED' &&
        activity.status != 'CANCELLED'
      "
    >
      <b-button
        @click="saveActivity"
        variant="success"
        class="mr-2"
        :disabled="!canSubmit || requestPending"
        v-if="this.$route.name == 'trainingAdd'"
        >{{ $t("common.submit") }}
      </b-button>
      <template v-else-if="!isMod || (isMod && activity.status == 'PROPOSED') || isAdmin">
        <b-button
          @click="saveActivity"
          variant="success"
          class="mr-5"
          :disabled="requestPending"
          >{{ $t("common.save") }}
        </b-button>
        <b-button
          @click="resetActivityForm"
          variant="warning"
          v-if="this.$route.name != 'trainingView'"
          >{{ $t("common.reset") }}
        </b-button>
      </template>
      <template v-if="activity.status == 'PROPOSED' && isAdmin">
        <b-button
          @click="acceptActivity"
          variant="primary"
          class="mr-2 esep-blue-bg"
          :disabled="requestPending"
          >{{ $t("training-view.accept") }}
        </b-button>
        <b-button
          @click="$bvModal.show('show-withdraw-modal')"
          variant="danger"
          :disabled="!comments || requestPending"
          v-b-tooltip.hover
          :title="$t('training-view.requiredComments')"
          >{{ $t("training-view.reject") }}
        </b-button>
        <b-form-group
          id="input-reject-comments"
          :label="$t('training-view.comments')"
          label-for="input-reject-comments"
          label-align="left"
          label-cols-md="3"
          content-cols-md
          class="col my-auto"
        >
          <b-form-input
            id="input-reject-comments"
            type="text"
            v-model="comments"
            placeholder=""
          ></b-form-input>
        </b-form-group>
      </template>
      <template v-else-if="activity.status == 'SCHEDULED' && isAdmin">
        <b-button
          @click="$bvModal.show('show-withdraw-modal')"
          variant="danger"
          :disabled="requestPending"
          >{{ $t("training-view.cancelTraining") }}
        </b-button>
        <b-button
          @click="updateForSubmissionModal"
          variant="primary"
          class="ml-2 mr-2 esep-blue-bg"
          :disabled="requestPending"
          >{{ $t("training-view.updateForSubmission") }}
        </b-button>
      </template>

      <template
        v-else-if="activity.status == 'TO_BE_SUBMITTED' && (isAdmin || isTrainer)"
      >
        <b-button
          @click="submitActivity"
          variant="primary"
          class="mr-2 esep-blue-bg"
          :disabled="requestPending"
          >{{ $t("training-view.submit") }}
        </b-button>
      </template>
      <template v-else-if="activity.status == 'PENDING_APPROVAL' && isAdmin">
        <b-button
          @click="approveActivity(true)"
          variant="primary"
          class="mr-2 esep-blue-bg"
          :disabled="requestPending"
          >{{ $t("training-view.approve") }}
        </b-button>
        <b-button
          @click="$bvModal.show('show-withdraw-modal')"
          variant="danger"
          :disabled="!comments"
          v-b-tooltip.hover
          :title="$t('training-view.requiredComments')"
          >{{ $t("training-view.cancel") }}
        </b-button>
        <b-form-group
          id="input-reject-comments"
          :label="$t('training-view.comments')"
          label-for="input-reject-comments"
          label-align="left"
          label-cols-md="2"
          label-cols-lg="1"
          content-cols-md
          class="col my-auto"
        >
          <b-form-input
            id="input-reject-comments"
            type="text"
            v-model="comments"
            placeholder=""
          ></b-form-input>
        </b-form-group>
      </template>
      <template
        v-else-if="activity.status == 'APPROVED' && (isAdmin || isTrainer)"
        :disabled="requestPending"
      >
        <b-button
          @click="toBeCompleteActivityWarning"
          variant="primary"
          class="mr-2 esep-blue-bg"
          >{{ $t("training-view.toBeComplete") }}
        </b-button>
      </template>
      <template v-else-if="activity.status == 'TO_BE_COMPLETED' && isAdmin">
        <b-button
          @click="completeActivity"
          variant="primary"
          class="mr-2 esep-blue-bg"
          :disabled="requestPending"
          >{{ $t("training-view.complete") }}
        </b-button>
        <b-button
          @click="revertActivity"
          variant="danger"
          class="mr-2"
          :disabled="requestPending"
          >{{ $t("training-view.revert") }}
        </b-button>
      </template>
    </div>
    <template v-else-if="activity.status == 'REJECTED'">
      <b-form-group
        id="input-reject-comments"
        :label="$t('training-view.comments')"
        label-for="input-reject-comments"
        label-align="right"
        label-cols-md="3"
        content-cols-md
        class="col my-auto"
      >
        <b-form-input
          id="input-reject-comments"
          type="text"
          v-model="comments"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </template>
    <template v-else-if="activity.status == 'CANCELLED'">
      <b-form-group
        id="input-reject-comments"
        v-if="comments != null"
        :label="$t('training-view.comments')"
        label-for="input-reject-comments"
        label-align="right"
        label-cols-md="3"
        content-cols-md
        class="col my-auto"
      >
        <b-form-input
          id="input-reject-comments"
          type="text"
          v-model="comments"
          disabled
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </template>
    <b-modal
      ref="to-be-submitted-modal"
      :title="$t('training-view.toBeSubmittedCheck')"
      no-close-on-backdrop
    >
      <p>
        <b-icon icon="exclamation-triangle"></b-icon>
        {{ $t("training-view.youAreAboutToSubmit") }}
      </p>

      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="updateForSubmissionActivity()">
          {{ $t("common.confirm") }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("common.cancel") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="show-withdraw-modal"
      :title="$t('trainings.withdrawTraining')"
      no-close-on-backdrop
    >
      <p>Είστε σίγουροι ότι θέλετε να ακυρώσετε αυτήν την εκπαίδευση;</p>

      <template v-slot:modal-footer="{ cancel }" hidden="true">
        <div>
          <b-button
            size="sm"
            @click="hideWithdrawTrainingSkeleton()"
            variant="success"
            class="mr-1"
            >{{ $t("common.submit") }}</b-button
          >
          <b-button size="sm" @click="cancel()" variant="danger">{{
            $t("common.cancel")
          }}</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="to-be-completed-modal"
      :title="$t('training-view.moveToToBeCompleted')"
      no-close-on-backdrop
    >
      <p>
        <b-icon icon="exclamation-triangle"></b-icon>
        {{
          $t("training-view.haveEvaluated", {
            needed: totalParticipants,
            done: evalParticipants,
          })
        }}
      </p>
      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="toBeCompleteActivity()">
          {{ $t("common.confirm") }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("common.cancel") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import { handleApiError } from "../../services/error.service";
import { prettifyDateTime } from "@/services/utils";
import axios from "axios";

const today = new Date();

export default {
  computed: {
    canChangePaymentTypes() {
      return (
        this.activity.id == null ||
        (["SCHEDULED", "PROPOSED"].includes(this.activity?.status) && this.isAdmin)
      );
    },
    activityCost() {
      return this.activity?.module?.billMethod?.rules?.length > 0
        ? this.activity.module.billMethod.rules[0].billingValue / 100
        : 0;
    },
    canSubmit() {
      let canSubmit = false;
      let activity = this.activity;
      if (
        activity.module &&
        activity.organizerUnit &&
        activity.applicationsExpireDate &&
        activity.periods?.length > 0 &&
        !this.invalidApplicationsDate
      ) {
        canSubmit = true;
      }
      return canSubmit;
    },
    isAdmin() {
      let isAdmin = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (
          userInfo.roles[i].name == "ADMIN" ||
          userInfo.roles[i].name == "TRAINING_ADMIN"
        ) {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    isMod() {
      let isMod = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAIN_MOD") {
          isMod = true;
        }
      }
      return isMod;
    },
    isTrainer() {
      let isTrainer = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAINER") {
          isTrainer = true;
        }
      }
      return isTrainer;
    },
    invalidApplicationsDate() {
      let isInvalid = false;
      if (this.activity.periods) {
        this.activity.periods.forEach((period) => {
          if (this.activity.applicationsExpireDate >= period.startDate) {
            isInvalid = true;
            return isInvalid;
          }
        });
      }
      return isInvalid;
    },
  },
  props: {
    activity: {
      type: Object,
    },
  },
  mounted() {
    if (this.activity.status == "REJECTED" || this.activity.status == "CANCELLED") {
      this.getActivitysComments();
    }
    this.getAllModules();
    this.getAllTemplates();
    this.getUnits();
    this.getTrainersByModuleId();
    this.getAllTrainers();
    // this.getActiveLeaders();
    if (this.activity.leaders.length > 0) {
      this.activity.leaders.forEach((leader) => {
        if (leader.position == "LEADER") {
          this.trainingLeader = {
            label: leader.member.surName + " " + leader.member.firstName,
            id: leader.member.id,
            cinfo: leader.member.cinfo,
          };
        } else if (leader.position == "PROGRAM_SUBLEADER") {
          this.programSubleader = {
            label: leader.member.surName + " " + leader.member.firstName,
            cinfo: leader.member.cinfo,
            id: leader.member.id,
          };
        } else if (leader.position == "LOGISTICS_SUBLEADER") {
          this.logisticsSubleader = {
            label: leader.member.surName + " " + leader.member.firstName,
            id: leader.member.id,
            cinfo: leader.member.cinfo,
          };
        } else if (leader.position == "SECRETARY") {
          this.secretary = {
            label: leader.member.surName + " " + leader.member.firstName,
            id: leader.member.id,
            cinfo: leader.member.cinfo,
          };
        }
      });
    } else {
      this.trainingLeader = {
        id: null,
        label: null,
        cinfo: {
          telNo: null,
          cellNo: null,
          email: null,
        },
      };
    }
  },
  data() {
    return {
      showWithdrawTraining: false,
      requestPending: false,
      training: null,
      templates: [],
      emptyActivity: {
        module: {
          id: null,
          billMethod: {
            rules: [{ billingValue: 0 }],
          },
        },
        orgUnit: {
          id: null,
          name: this.$t("common.unit-selector.selectAUnit"),
        },
        method: "LIVE",
        status: "PROPOSED",
        applicationsDate: null,
        periods: [],
        leaders: [],
        location: null,
        trainingLeader: {
          label: null,
          id: null,
          cinfo: {
            telNo: null,
            cellNo: null,
            email: null,
          },
        },
        paymentTypes: [],
      },
      trainingPeriod: {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        location: null,
      },
      fields: [
        {
          key: "startDate",
          label: "Ημερομηνία Από",
          sortable: false,
          formatter: "prettifyDate",
        },
        {
          key: "endDate",
          label: "Ημερομηνία Εώς",
          sortable: false,
          formatter: "prettifyDate",
        },
        {
          key: "location",
          label: "Τοποθεσία",
          sortable: false,
          thClass: "text-left",
          tdClass: "text-left",
        },
        { key: "action", label: "Ενέργεια", sortable: false },
      ],
      paymentTypeOptions: [
        { value: "RF_CODE", text: this.$t("paymentTypeEnums.RF_CODE") },
        { value: "FINANCE_DEP", text: this.$t("paymentTypeEnums.FINANCE_DEP") },
        { value: "BANK", text: this.$t("paymentTypeEnums.BANK") },
        { value: "IN_PERSON", text: this.$t("paymentTypeEnums.IN_PERSON") },
      ],
      moduleTrainers: null,
      branchTrainers: null,
      activeLeaders: [],
      evalParticipants: 0,
      totalParticipants: 0,
      trainingLeader: {
        label: null,
        id: null,
        cinfo: {
          telNo: null,
          cellNo: null,
          email: null,
        },
      },
      programSubleader: {
        id: null,
        label: null,
        cinfo: {
          telNo: null,
          cellNo: null,
          email: null,
        },
      },
      logisticsSubleader: {
        id: null,
        label: null,
        cinfo: {
          telNo: null,
          cellNo: null,
          email: null,
        },
      },
      secretary: {
        id: null,
        label: null,
        cinfo: {
          telNo: null,
          cellNo: null,
          email: null,
        },
      },
      modules: null,
      cancelSource: null,
      units: null,
      today: today,
      comments: null,
      activityMethods: [
        {
          value: "DISTANT_LEARNING",
          text: this.$t("trainingMethodEnums.DISTANT_LEARNING"),
        },
        { value: "ELEARNING", text: this.$t("trainingMethodEnums.ELEARNING") },
        { value: "LIVE", text: this.$t("trainingMethodEnums.LIVE") },
        { value: "ONLINE_MANUAL", text: this.$t("trainingMethodEnums.ONLINE_MANUAL") },
        { value: "QUESTIONNAIRE", text: this.$t("trainingMethodEnums.QUESTIONNAIRE") },
      ],
    };
  },
  methods: {
    prettifyDate(stringDate) {
      return prettifyDateTime(stringDate);
    },
    addPeriod() {
      let startDate = new Date(
        this.trainingPeriod.startDate + " " + this.trainingPeriod.startTime
      );
      let endDate = new Date(
        this.trainingPeriod.endDate + " " + this.trainingPeriod.endTime
      );

      this.trainingPeriod.startDate = startDate;
      this.trainingPeriod.endDate = endDate;

      this.activity.periods.push(this.trainingPeriod);
      this.trainingPeriod = {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        location: null,
      };
    },
    deletePeriod(period) {
      if (this.$route.name == "trainingView" && period.item.id) {
        trainingService.deletePeriod(this.activity.id, period.item.id).then(
          (response) => {
            this.$log.debug(response.data);
            for (let i = 0; i < this.activity.periods.length; i++) {
              if (period.index == i) {
                this.activity.periods.splice(i, 1);
              }
            }
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
          }
        );
      } else {
        for (let i = 0; i < this.activity.periods.length; i++) {
          if (period.index == i) {
            this.activity.periods.splice(i, 1);
          }
        }
      }
    },
    saveActivity() {
      if (this.$route.name == "trainingAdd") {
        this.activity.unit = { id: this.activity.organizerUnit };
        this.activity.leader = { id: this.trainingLeader?.id };
        this.activity.applicationDate = this.activity.applicationsExpireDate;
        if (this.isAdmin) {
          this.scheduleActivity(this.activity);
        } else {
          this.activity.unit = this.activity.organizerUnit;
          this.requestPending = true;
          trainingService.proposeActivity(this.activity).then(
            (response) => {
              this.$log.debug(response.data);
              this.$router.push({
                name: "trainingView",
                params: { id: response.data.id },
              });
              this.requestPending = false;
            },
            (error) => {
              let errorMessage = handleApiError(error);
              this.$emit("error:api", errorMessage);
              this.requestPending = false;
            }
          );
        }
      } else {
        let leaders = this.activity.leaders;
        let periods = this.activity.periods;
        this.requestPending = true;
        trainingService.updateActivity(this.activity, leaders, periods).then(
          () => {
            this.$emit("activity-saved", this.$t("training-view.activityUpdated"));
            this.$emit("leaders-changed", leaders);
            this.requestPending = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
            this.requestPending = false;
          }
        );
      }
    },
    scheduleActivity(activity) {
      this.requestPending = true;
      this.activity.leader = { id: this.trainingLeader?.id };
      trainingService.scheduleActivity(activity).then(
        (response) => {
          if (this.$route.name != "trainingView") {
            this.$router.push({ name: "trainingView", params: { id: response.data.id } });
          } else {
            this.$emit("activity-saved", this.$t("training-view.activityScheduled"));
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
          this.requestPending = false;
        }
      );
    },
    acceptActivity() {
      this.scheduleActivity(this.activity);
    },
    rejectActivity() {
      this.requestPending = true;
      this.requestPending = true;
      trainingService
        .changeActivityStatus(this.activity.id, "REJECTED", this.comments)
        .then(
          (response) => {
            this.$log.debug(response.data);
            this.$emit("activity-saved", this.$t("training-view.activityRejected"));
            this.requestPending = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
            this.requestPending = false;
          }
        );
    },
    updateForSubmissionModal() {
      this.$refs["to-be-submitted-modal"].show();
    },
    updateForSubmissionActivity() {
      this.$refs["to-be-submitted-modal"].hide();
      this.requestPending = true;
      trainingService
        .changeActivityStatus(this.activity.id, "TO_BE_SUBMITTED", null)
        .then(
          (response) => {
            this.$log.debug(response.data);
            this.$emit(
              "activity-saved",
              this.$t("training-view.activityUpdatedForSubmission")
            );
            this.requestPending = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
            this.requestPending = false;
          }
        );
    },
    revertActivity() {
      this.requestPending = true;
      trainingService.revertActivity(this.activity.id).then(
        () => {
          this.$emit("activity-saved", this.$t("training-view.activityReverted"));
          this.requestPending = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
          this.requestPending = false;
        }
      );
    },
    submitActivity() {
      this.requestPending = true;
      trainingService
        .changeActivityStatus(this.activity.id, "PENDING_APPROVAL", null)
        .then(
          () => {
            this.$emit("activity-saved", this.$t("training-view.activitySubmitted"));
            this.requestPending = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
            this.requestPending = false;
          }
        );
    },
    approveActivity(approve) {
      this.requestPending = true;
      let status = "CANCELLED";
      if (approve) {
        status = "APPROVED";
      }
      trainingService.changeActivityStatus(this.activity.id, status, this.comments).then(
        () => {
          if (status == "CANCELLED") {
            this.$emit("activity-saved", this.$t("training-view.activityCancelled"));
          } else {
            this.$emit("activity-saved", this.$t("training-view.activityApproved"));
          }
          this.requestPending = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
          this.requestPending = false;
        }
      );
    },
    toBeCompleteActivityWarning() {
      trainingService.getActivitysEvaluationParticipants(this.activity.id).then(
        (response) => {
          this.evalParticipants = response.data.evalParticipants;
          this.totalParticipants = response.data.totalParticipants;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
      this.$refs["to-be-completed-modal"].show();
    },
    toBeCompleteActivity() {
      this.$refs["to-be-completed-modal"].hide();
      this.requestPending = true;
      trainingService
        .changeActivityStatus(this.activity.id, "TO_BE_COMPLETED", null)
        .then(
          (response) => {
            this.$log.debug(response.data);
            if (this.isAdmin) {
              this.$emit(
                "activity-saved",
                this.$t("training-view.activityUpdateForCompletion")
              );
            } else {
              this.$router.push({ name: "trainings" });
            }
            this.requestPending = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
            this.requestPending = false;
          }
        );
    },
    completeActivity() {
      this.requestPending = true;
      trainingService.changeActivityStatus(this.activity.id, "COMPLETED", null).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit("activity-saved", this.$t("training-view.activityCompleted"));
          this.requestPending = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
          this.requestPending = false;
        }
      );
    },
    staffChanged(position, member) {
      if (this.$route.name == "trainingView") {
        let leaderExists = false;
        for (let i = 0; i < this.activity.leaders.length; i++) {
          const leader = this.activity.leaders[i];

          if (leader.member?.id == member.id) {
            leaderExists = true;
            this.activity.leaders[i].position = position;
          } else {
            if (leader.position == position) {
              this.activity.leaders[i].position = "TRAINER";
            }
          }
        }
        if (!leaderExists) {
          let newLeader = {
            member: { id: member.id },
            position: position,
            partTime: false,
            type: "BOTH",
          };
          trainingService.addLeader(this.activity.id, newLeader).then(
            (response) => {
              let leaders = this.activity.leaders;
              leaders.push(response.data);
              this.$emit("leaders-changed", leaders);
            },
            (error) => {
              let errorMessage = handleApiError(error);
              this.$emit("error:api", errorMessage);
            }
          );
        } else {
          let leaders = this.activity.leaders;
          this.$emit("leaders-changed", leaders);
        }
      } else {
        let newLeader = {
          member: { id: member.id },
          position: position,
          partTime: false,
          type: "BOTH",
        };
        this.activity.leaders.push(newLeader);
        this.$emit("leaders-changed", this.activity.leaders);
      }
    },
    resetActivityForm() {
      this.activity = this.emptyActivity;
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true, null, false).then(
        (response) => {
          this.$log.debug(response.data);
          this.modules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    getAllTemplates() {
      trainingService.getAnnouncementTemplatesByCriteria().then(
        (response) => {
          this.templates = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    getTrainersByModuleId() {
      if (this.activity.module.id != null) {
        trainingService.getTrainersByBranch(null, this.activity.module.id).then(
          (response) => {
            this.$log.debug("moduleTrainers");
            this.$log.debug(response.data);
            let temp = [];
            response.data.forEach((trainer) => {
              temp.push({
                label: `${trainer.member.surName} ${trainer.member.firstName} (${trainer.activityCount}/${trainer.totalActivityCount})`,
                id: trainer.member.id,
                cinfo: trainer.member.cinfo,
              });
            });
            this.moduleTrainers = temp;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit("error:api", errorMessage);
          }
        );
      } else {
        this.moduleTrainers = [];
      }
    },
    getAllTrainers() {
      trainingService.getTrainersByBranch(null).then(
        (response) => {
          let temp = [];
          response.data.forEach((trainer) => {
            temp.push({
              label: `${trainer.member.surName} ${trainer.member.firstName} (${trainer.activityCount}/${trainer.totalActivityCount})`,
              id: trainer.member.id,
              cinfo: trainer.member.cinfo,
            });
          });
          this.branchTrainers = temp;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("cancel");
      }
    },
    getActiveLeaders(search, loading) {
      if (search.length < 2) {
        return;
      }
      loading(true);
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      trainingService.getActiveLeaders(search).then(
        (response) => {
          let temp = [];
          response.data.forEach((trainer) => {
            temp.push({
              label: trainer.surName + " " + trainer.firstName,
              member: trainer,
            });
          });
          this.activeLeaders = temp;

          loading(false);
          this.cancelSource = null;
        },
        (error) => {
          if (error.message === "cancel") return;
          loading(false);
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    getUnits() {
      trainingService.getUsersPermissions().then(
        (response) => {
          let trainUnits;
          trainUnits = response.data.TRAIN_UNIT || [];
          if (this.isAdmin) {
            trainUnits.push(...(response.data.ADMIN_UNIT || []));
          }

          if (trainUnits) {
            this.units = trainUnits
              .filter((unit) => unit.type == "DISTRICT")
              .filter((unit) => unit.status == "ACTIVE");
          } else {
            this.units = [];
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    getActivitysComments() {
      trainingService.getActivitysComments(this.activity.id, this.activity.status).then(
        (response) => {
          this.$log.debug(response.data);
          this.comments = response.data[0].rejectComments;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    unitSelected(unit) {
      if (!this.canChangePaymentTypes) {
        return;
      }
      if (this.activityCost < 1) {
        this.activity.paymentTypes = ["NONE"];
        return;
      }
      if (unit && unit.districtType == "GENERAL") {
        this.activity.paymentTypes = ["RF_CODE", "FINANCE_DEP"];
      } else {
        this.activity.paymentTypes = ["BANK", "IN_PERSON"];
      }
    },
    hideWithdrawTrainingSkeleton() {
      if (this.activity.status == "PROPOSED") {
        this.rejectActivity();
      } else {
        this.approveActivity(false);
      }
      this.$bvModal.hide("show-withdraw-modal");
    },
  },
};
</script>

<style>
/* -- Hiding arrows from number input types -- */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.telephone {
  padding: 0.375rem 0.55rem;
}
.modal-header {
  background-color: #1565c0;
  color: white;
}
.modal-footer {
  border-top: 0 none;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
